import React, { lazy } from 'react';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ProductShowcase() {
  const benefits = ['100% Vegan Certified Creatine', 'Zero Sugar, Natural Fruit Flavor', 'Third-party Tested for Purity', 'Brain Clarity & Energy Support'];
  return <div className="bg-white border-2 border-accent/20 rounded-xl overflow-hidden my-8 md:my-12 shadow-lg" data-id="element-7">
      <div className="bg-accent text-white text-center py-2 font-bold font-sans uppercase tracking-wider text-xs md:text-sm" data-id="element-8">
        Special Offer for Readers
      </div>
      <div className="p-6 md:p-8 lg:p-10" data-id="element-9">
        <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-center" data-id="element-10">
          <div className="w-full md:w-1/2" data-id="element-11">
            <div className="aspect-square bg-gray-100 rounded-lg flex items-center justify-center relative overflow-hidden" data-id="element-12">
              <img src="https://cdn.shopify.com/s/files/1/0936/8453/1542/files/Untitled_design_38.png?v=1768538555" alt="Loomy Vegan Creatine Gummies" className="w-full h-full object-cover" loading="lazy" decoding="async" width="600" height="600" data-id="element-13" />
            </div>
          </div>
          <div className="w-full md:w-1/2 space-y-4 md:space-y-6" data-id="element-14">
            <div data-id="element-15">
              <h3 className="text-2xl md:text-3xl font-serif font-bold text-gray-900 mb-2" data-id="element-16">
                Loomy Vegan Creatine
              </h3>
              <p className="text-gray-600 font-sans text-sm md:text-base" data-id="element-17">
                The missing link for plant-based clarity.
              </p>
            </div>

            <ul className="space-y-2 md:space-y-3" data-id="element-18">
              {benefits.map((benefit, i) => <li key={i} className="flex items-start gap-2 md:gap-3" data-id="element-19">
                  <div className="mt-1 bg-green-100 rounded-full p-1" data-id="element-20">
                    <Check className="w-3 h-3 text-green-700" strokeWidth={4} data-id="element-21" />
                  </div>
                  <span className="text-gray-800 font-medium text-sm md:text-base" data-id="element-22">
                    {benefit}
                  </span>
                </li>)}
            </ul>

            <div className="pt-3 md:pt-4 border-t border-gray-100" data-id="element-23">
              <CTAButton fullWidth data-id="element-24">Try Loomy Risk-Free</CTAButton>
              <p className="text-center text-xs text-gray-500 mt-2 md:mt-3" data-id="element-25">
                30-day money-back guarantee. Free shipping.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}